import React from 'react'

const NameViewUI = ({context, firstName, lastName}) =>
  <div>
    {firstName} {lastName}
  </div>

export default NameViewUI
